import EmptyList from '@anm/components/EmptyList';
import AddDestinationWithModals from '@anm/components/stream/destination_management/AddDestinationWithModals';
import DestinationWarning from '@anm/components/stream/destination_management/DestinationWarning';
import useDestinationsList from '@anm/components/stream/destination_management/hooks/useDestinationList';
import { FC } from 'react';

import config from '../../../../config';
import StreamItemWrapper from '../../../stream/SteamItemWrapper';
import Loader from '../Loader';
import Pagination from '../Pagination';
import { SectionWrapper } from '../Wrapper';
import { getEmptyListProps, getStreamKey } from '../helpers';
import { useUpcomingStreams } from '../hooks/useStreamsList';

const { urls } = config();

const UpcomingTab: FC = () => {
  const [isPending, list, isError] = useUpcomingStreams();
  const [_, destinationList] = useDestinationsList(false);

  if (isPending) return <Loader />;

  const emptyListProps = getEmptyListProps({ isError });

  if (isError || !list?.length) {
    return <EmptyList isArrow={!isError} {...emptyListProps} />;
  }

  return (
    <SectionWrapper>
      <AddDestinationWithModals
        waveUrl={urls.wave}
        waveApiUrl={urls.apiWave}
        isReconnect={true}
        renderChildren={destinations => <DestinationWarning list={destinationList} destinations={destinations} />}
      />
      {list?.map(item => (
        <StreamItemWrapper key={getStreamKey(item)} {...item} />
      ))}
      <Pagination />
    </SectionWrapper>
  );
};

export default UpcomingTab;
